import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { UpaAsyncService } from '../../../services/upa-async.service';
import { AssetsUrlPipe } from '../../../pipes/assets-url.pipe';
import { ModalComponent } from '../../shared/modal/modal.component';
import { redirectToUrl } from '../utils/navigation.utils';
import {
  VIEW_ALL_COUPONS,
  COUPON_URLS,
  LOGIN_URL
} from '../utils/urls.constants';

@Component({
  selector: 'al-coupons',
  standalone: true,
  imports: [CommonModule, AssetsUrlPipe, ModalComponent],
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss']
})
export class CouponsComponent {
  @Input() isEnrolled = false;
  @Input() isLoggedIn = false;
  @Input() source = '';

  upaAsyncService = inject(UpaAsyncService);

  private touchStartY: number | null = null;
  private touchEndY: number | null = null;

  showCouponToast = false;

  showCouponsStepsModal = false;

  copiedCoupon: 'DECOLAR8IFOOD' | 'HOTEL15IFOOD' | 'PACOTES10IFOOD' | null = null;
  selectedCouponIndex = 0;

  coupons = [
    {
      code: 'PACOTES10IFOOD',
      title: '1ª compra Pacotes',
      subtitle: '10% OFF na sua 1ª compra de pacote com voo + hotel',
      expiry: 'Vencimento 18/06/2026',
      img: 'cupon-pacote.svg',
    },
    {
      code: 'HOTEL15IFOOD',
      title: '1ª compra Hotéis',
      subtitle: '15% OFF na sua 1ª compra de qualquer hotel',
      expiry: 'Vencimento 18/06/2026',
      img: 'cupon-hotels.svg',
    },
    {
      code: 'DECOLAR8IFOOD',
      title: '1ª compra',
      subtitle: '8% OFF para sua primeira compra',
      expiry: 'Vencimento 31/07/2026',
      img: 'cupon-default.svg',
    }
  ];

  onCouponCarouselScroll(event: Event) {
    const target = event.target as HTMLElement;
    const scrollLeft = target.scrollLeft;
    const scrollWidth = target.scrollWidth;
    const clientWidth = target.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    if (maxScroll <= 0) {
      this.selectedCouponIndex = 0;
      return;
    }
    const percent = scrollLeft / maxScroll;
    if (percent < 0.33) {
      this.selectedCouponIndex = 0;
    } else if (percent < 0.66) {
      this.selectedCouponIndex = 1;
    } else {
      this.selectedCouponIndex = 2;
    }
  }

  onCopyCoupon(codigo: string): void {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(codigo);
    }
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        `copiar_cupon_${codigo}`,
        'click',
        'ifood-landing',
        { codigo, source: this.source }
      )
      .subscribe();
    this.copiedCoupon = codigo as any;
    this.showCouponToast = true;
    setTimeout(() => {
      this.showCouponToast = false;
    }, 5000);
  }

  onCloseToast(): void {
    this.showCouponToast = false;
  }

  onCloseToastKey(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onCloseToast();
    }
  }

  onUseNowCoupon(codigo: string): void {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        `cupons_usar_agora_${codigo}`,
        'click',
        'ifood-landing',
        { codigo, source: this.source }
      )
      .subscribe();
    redirectToUrl(COUPON_URLS[codigo]);
    this.copiedCoupon = null;
  }

  onViewAllCouponsClick(): void {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'ver_todos_os_cupons',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(VIEW_ALL_COUPONS);
  }

  onCouponLoginClick() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'cupon_fazer_login',
        'click',
        'ifood-landing', {
        source: this.source,
      })
      .subscribe();
    redirectToUrl(LOGIN_URL);
  }

  closeModal() {
    this.closeCouponsStepsModal();
  }

  modalTouchStart(event: TouchEvent) {
    this.touchStartY = event.touches[0].clientY;
  }

  modalTouchMove(event: TouchEvent) {
    this.touchEndY = event.touches[0].clientY;
  }

  modalTouchEnd() {
    if (
      this.touchStartY !== null &&
      this.touchEndY !== null &&
      this.touchEndY - this.touchStartY > 60
    ) {
      this.closeCouponsStepsModal();
    }
    this.touchStartY = null;
    this.touchEndY = null;
  }

  openCouponsStepsModal() {
    this.showCouponsStepsModal = true;
  }

  closeCouponsStepsModal() {
    this.showCouponsStepsModal = false;
  }

  selectCoupon(i: number) {
    if (i === this.selectedCouponIndex) return;
    this.selectedCouponIndex = i;
  }

}
